var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_1",
    "data-name": "Arrow 1",
    transform: "translate(14 11) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M3.888,13.19A2.183,2.183,0,0,0,5.506,14a2.176,2.176,0,0,0,1.611-.8l3.51-3.9a1.56,1.56,0,0,0,.118-.139,1.256,1.256,0,0,0,.1-1.356.99.99,0,0,0-1.163-.533,1.339,1.339,0,0,0-.58.377Q7.964,8.905,6.829,10.17l-.255.284V1.323a2.317,2.317,0,0,0,0-.234A1.113,1.113,0,0,0,5.925.1.976.976,0,0,0,4.793.3a1.317,1.317,0,0,0-.36,1l0,9.151L1.9,7.646a1.731,1.731,0,0,0-.191-.189,1,1,0,0,0-.989-.17,1.128,1.128,0,0,0-.685.81,1.251,1.251,0,0,0,.32,1.177Z",
    transform: "translate(0 11) rotate(-90)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.4681e0153faa4019b7aab6acfd9eea8c.svg";
export { ForwardRef as ReactComponent };